import React, {Suspense, lazy, useState, useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from "./components/Layout/Layout";
import csCZ from "./js/collections/cs-CZ";
import CzechFlag from "./images/flags/csCZ.png";
import enGB from "./js/collections/en-GB";
import EnglishFlag from "./images/flags/enGB.png";
import Language from "./enums/LanguageEnum";

const Home = lazy(() => import('./routes/Home'));
const Privacy = lazy(() => import('./routes/Privacy'));
const AlphaBaby = lazy(() => import('./routes/AlphaBaby/AlphaBaby'));
const Pairs = lazy(() => import('./routes/Pairs/Pairs'));

const App = () => {
    const languageDetails = {
        [Language.Czech.name]: {
            collection: csCZ,
            flag: {
                src: CzechFlag,
                alt: "CZ"
            }
        },
        [Language.English.name]: {
            collection: enGB,
            flag: {
                src: EnglishFlag,
                alt: "GB"
            }
        }
    }

    const [containerHeight, setContainerHeight] = useState(null);
    const [containerWidth, setContainerWidth] = useState(null);

    const selectedLanguage = sessionStorage.getItem("ABLanguage") || Language.English.name;
    const [language, setLanguage] = useState({
        name: selectedLanguage,
        data: languageDetails[selectedLanguage]
    });

    const updateContainerWidth = (width) =>{
        setContainerWidth(width);
    }
    const updateContainerHeight = (height) =>{
        setContainerHeight(height);
    }

    const updateLanguage = (e, language) => {
        console.log("passed", e, language);
        setLanguage({
            name: language,
            data: languageDetails[language]
        })
        sessionStorage.setItem("ABLanguage", language);
    }

    const getLanguage = (language) => {
        return languageDetails[language];
    }

    return (
        <Router>
            <Layout language={language} updateLanguage={updateLanguage} getLanguage={getLanguage} updateContainerWidth={updateContainerWidth} updateContainerHeight={updateContainerHeight}>
                <Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/alpha-baby" element={<AlphaBaby language={language} />} />
                        <Route path="/pairs" element={<Pairs language={language} containerWidth={containerWidth} containerHeight={containerHeight} />} />
                    </Routes>
                </Suspense>
            </Layout>
        </Router>
    )
};

window.addEventListener('orientationchange', refreshPage);

function refreshPage() {
    console.log("RELOAD")
    window.location.reload();
}

export default App;
